export class UnitDataDto {

    unitId: number;
    unitName: string;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    updatedAt: Date;
    versionFlag: number;
    

    constructor(
        unitId: number,
        unitName: string,
        isActive: boolean,
        createdUser: string | null,
        createdAt: Date,
        updatedUser: string | null,
        updatedAt: Date,
        versionFlag: number,
        
    ) {
        this.unitId = unitId;
        this.unitName = unitName;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.createdAt = createdAt;
        this.updatedUser = updatedUser;
        this.updatedAt = updatedAt;
        this.versionFlag = versionFlag;
    }
}
